import { BrushProps, MaskType } from "../pages/FiboEdit/MaskEditor/ControlPanel/ControlPanel";
import { IGenerationStepsSliderProps } from "../pages/FiboEdit/Steps/FiboEditSteps";

export const DEFAULT_MASK_EDITOR_BRUSH_PROPS: BrushProps = Object.freeze({
	size: 50,
	type: "brush" as MaskType,
});

export const FIBO_EDIT_STEPS_DEFAULT_PROPS: IGenerationStepsSliderProps = Object.freeze({
	min: 30,
	max: 50,
	steps: 30,
});
